<template>
    <v-row>
        <v-col cols="12">
            <v-row no-gutters style="height: 60px;">
                <v-sheet color="black" tile height="60px" width="100%" class="blackSheetStyle">
                    <v-row no-gutters style="height: 60px;">
                        <v-col cols="auto" align-self="center" class="px-2">
                            <v-btn icon @click="goToLog">
                                <v-img src="@/assets/icons/arrow-u-left-top.svg" max-width="36px" />
                            </v-btn>
                        </v-col>
                        <v-spacer></v-spacer>
                        <v-col cols="auto" align-self="center" class="px-2">
                            <span class="title-style">Journey Memories</span>
                        </v-col>
                        <v-spacer></v-spacer>
                        <v-col cols="auto" align-self="center" class="px-2">
                            <v-btn v-if="hasValidImage" icon @click="showExtras = !showExtras" :disabled="downloading || uploading">
                                <v-img src="@/assets/icons/dots-vertical.svg" max-width="36px" />
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-sheet>
            </v-row>
        </v-col>

        <v-col cols="12" class="py-0">
            <v-img contain
                       position="top center"
                       max-height="56px"
                       max-width="200px"
                       class="logoOnTop"
                       src="/img/logo.png">
            </v-img>
        </v-col>

        <v-col cols="12" class="pt-0">
            <v-row class="pa-2" id="galleryContainer">
                <v-col cols="6" class="pr-2 pb-2">
                    <v-skeleton-loader v-if="downloading"
                                       height="150px"
                                       class="image-frame"
                                       type="image">
                    </v-skeleton-loader>
                    <v-img v-else @click="showDialog(0)" class="image-frame" height="150px" cover :src="images[0].url">
                        <template v-if="!images[0].url">
                            <v-row class="fill-height ma-0" align="center" justify="center">
                                <span class="text--white80">Click here to upload</span>
                            </v-row>
                        </template>
                    </v-img>
                </v-col>

                <v-col cols="6" class="pl-0 pb-0">
                    <v-skeleton-loader v-if="downloading"
                                       height="150px"
                                       class="image-frame"
                                       type="image">
                    </v-skeleton-loader>
                    <v-img v-else @click="showDialog(1)" class="image-frame" height="150px" cover :src="images[1].url">
                        <template v-if="!images[1].url">
                            <v-row class="fill-height ma-0" align="center" justify="center">
                                <span class="text--white80">Click here to upload</span>
                            </v-row>
                        </template>
                    </v-img>
                </v-col>

                <v-col cols="12" class="py-0">
                    <v-skeleton-loader v-if="downloading"
                                       height="200px"
                                       class="image-frame"
                                       type="image">
                    </v-skeleton-loader>

                    <v-img v-else @click="showDialog(2)" class="image-frame" height="200px" cover :src="images[2].url">
                        <template v-if="!images[2].url">
                            <v-row class="fill-height ma-0" align="center" justify="center">
                                <span class="text--white80">Click here to upload</span>
                            </v-row>
                        </template>
                    </v-img>
                </v-col>

                <v-col cols="6" class="pr-2 pb-0 pt-2" height="">
                    <v-skeleton-loader v-if="downloading"
                                       height="200px"
                                       class="image-frame"
                                       type="image">
                    </v-skeleton-loader>
                    <v-img v-else @click="showDialog(3)" class="image-frame" height="250px" cover :src="images[3].url">
                        <template v-if="!images[3].url">
                            <v-row class="fill-height ma-0" align="center" justify="center">
                                <span class="text--white80">Click here to upload</span>
                            </v-row>
                        </template>
                    </v-img>
                </v-col>

                <v-col cols="6" class="pl-0 pb-0 pt-2">
                    <v-skeleton-loader v-if="downloading"
                                       height="200px"
                                       class="image-frame"
                                       type="image">
                    </v-skeleton-loader>
                    <v-img v-else @click="showDialog(4)" class="image-frame" height="250px" cover :src="images[4].url">
                        <template v-if="!images[4].url">
                            <v-row class="fill-height ma-0" align="center" justify="center">
                                <span class="text--white80">Click here to upload</span>
                            </v-row>
                        </template>
                    </v-img>
                </v-col>

                <v-col cols="12" class="py-4">
                    <v-row class="fill-height" align-content="center" justify="center">
                        <v-col cols="10" v-if="uploading" class="text-center text--white80 pb-1 pt-4">
                            Uploading...
                        </v-col>
                        <v-col cols="10" v-if="downloading" class="text-center text--white80 pb-1 pt-4">
                            Downloading...
                        </v-col>

                        <v-col v-if="uploading" cols="10" class="pt-0">
                            <v-progress-linear color="white"
                                               rounded
                                               height="16"
                                               :indeterminate="true"></v-progress-linear>
                        </v-col>
                        <v-col v-if="downloading" cols="10" class="pt-0">
                            <v-progress-linear v-model="downloadProgress"
                                               color="white"
                                               rounded
                                               height="16">
                                <template v-slot:default="{ value }">
                                    <strong>{{ downloadProgress }}%</strong>
                                </template>
                            </v-progress-linear>
                        </v-col>
                    </v-row>
                </v-col>

                <v-dialog v-model="showExtras"
                          scrollable
                          height="600"
                          style="top: -200px">
                    <v-card style="background-color: #FFFFFF;" :loading="showLoadingDialog">
                        <template slot="progress">
                            <v-progress-linear color="#00aa87"
                                               height="8"
                                               indeterminate></v-progress-linear>
                        </template>
                        <v-card-title>
                            <span class="headline">Extra options</span>
                        </v-card-title>
                        <v-divider></v-divider>
                        <v-card-text class="pb-0 px-6">
                            <v-list>
                                <v-list-item @click="captureAndShareBase(false)" :disabled="showLoadingDialog">
                                    <v-list-item-icon>
                                        <v-icon>mdi-share-variant-outline</v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-content>
                                        <v-list-item-title>Share journey memories</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>

                                <v-list-item @click="captureAndShareBase(true)" :disabled="showLoadingDialog">
                                    <v-list-item-icon>
                                        <v-icon>mdi-share-variant-outline</v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-content>
                                        <v-list-item-title>Share log and journey memories</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>

                            </v-list>
                        </v-card-text>
                        <v-divider></v-divider>
                        <v-card-actions>
                            <v-row>
                                <v-col cols="12" class="text-center px-0 py-4">
                                    <v-btn color="error"
                                           @click="showExtras = !showExtras">
                                        RETURN
                                        <v-icon right>
                                            mdi-arrow-u-left-top
                                        </v-icon>
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </v-card-actions>
                    </v-card>
                </v-dialog>

                <ImageUploadDialog :value="showImageDialog"
                                   :title="selectedImageIsPlaceholder ? 'Upload a new picture' : 'View journey memory'"
                                   :image-url="selectedImageIsPlaceholder || !images ? '' : images[selectedImageIndex].url"
                                   :busy="uploading"
                                   :show-file-input="selectedImageIsPlaceholder"
                                   :show-delete="!selectedImageIsPlaceholder && hasUploadAccess"
                                   :show-upload="selectedImageIsPlaceholder"
                                   :upload-disabled="!uploadFile"
                                   :file-rules="imageRules"
                                   :file-value="uploadFile"
                                   :preview-height="420"
                                   :preview-contain="true"
                                   preview-border-color="#000000"
                                   @input="setShowImageDialog"
                                   @file-change="handleFileChange"
                                   @delete="handleImageDelete"
                                   @upload="handleImageUpload"></ImageUploadDialog>

                <!--<LoadingDialog v-model="showLoadingDialog"
                               message="GENERATING ..." />-->

                <ShareDialog v-model="showShareDialog"
                             :model="{ headline: 'Ready to share', text: '', imageUrl: shareImageUrl}"
                             @OnShare="shareNow"
                             @OnCancel="showShareDialog = false">
                </ShareDialog>
            </v-row>
            </v-col>
    </v-row>
</template>

<script lang="ts">
    import { app } from "@/store";
    import { profile as profilestore } from "@/store/index";
    import ProfileViewModel from "@/models/ProfileViewModel";
    import { uploadImageToBlobStorage, downloadImageFromBlobStorage, deleteImageFromBlobStorage } from "@/store/useUserPictureStorage";
    import { defineComponent, ref, onMounted, computed, getCurrentInstance } from "vue";
    import useFavouriteJourney from "@/store/useFavouriteJourney";
    import FavouriteJourneyViewModel from "../models/FavouriteJourneyViewModel";
    import { domToBlob } from 'modern-screenshot'

    export default defineComponent({
        name: "UserImageGallery",
        components: {
            ConfirmDialog: () =>
                import(/* webpackChunkName: "settings" */ "./components/Dialogs/ConfirmDialog.vue"),
            ShareDialog: () =>
                import(/* webpackChunkName: "settings" */ "./components/Dialogs/ShareDialog.vue"),
            LoadingDialog: () =>
                import(/* webpackChunkName: "settings" */ "./components/Dialogs/LoadingDialog.vue"),
            ImageUploadDialog: () =>
                import(/* webpackChunkName: "settings" */ "./components/Dialogs/ImageUploadDialog.vue"),
        },
        setup() {
            const root = getCurrentInstance()?.proxy as any;

            // Constants
            const CANVAS_WIDTH = 1535;
            const START_HEIGHT = 320;
            const HORIZONTAL_GAP = 100;
            const VERTICAL_GAP = 50;
            const LARGE_VERTICAL_GAP = VERTICAL_GAP * 2;
            const BORDER_WIDTH = 5;
            const ELEMENT_COLOR = 'white';
            const IMAGE_FORMAT = 'image/jpeg';
            const SHARE_FILE_NAME = 'MarineOne.jpg';
            const LOGO_IMAGE_PATH = '/img/logo.png';
            const BACKGROUND_IMAGE_PATH = '/img/background_long.jpg';
            const TITLE = "Journey Memories";

            const { getFavouriteJourney, updateFavouriteJourney } = useFavouriteJourney();
            const id = root.$route.params.ids || root.$route.params.id;
            const deviceId = root.$route.params.deviceId;
            const logFileName = root.$route.params.logFile;
            const showImageDialog = ref(false);
            const showExtras = ref(false);
            const selectedImageIndex = ref(0);
            const selectedImageIsPlaceholder = ref(false);
            const images = ref([]);
            const fileSelected = ref(false);
            const uploading = ref(false);
            const downloading = ref(false);
            const uploadFile = ref<File | null>(null);
            const showLoadingDialog = ref(false);
            const showShareDialog = ref(false);
            let file: File;
            const downloadProgress = ref(0);
            const journey = ref(new FavouriteJourneyViewModel());
            const shareImageUrl = ref("");

            const profile = computed<ProfileViewModel>(() => {
                return profilestore.profile;
            });

            const hasUploadAccess = computed<boolean>(() => {
                return profile.value ? profile.value.hasUploadAccess : false;
            });

            images.value = [
                { url: '' },
                { url: '' },
                { url: '' },
                { url: '' },
                { url: '' }
            ];

            const hasValidImage = computed(() => {
                return !images.value.every(img => img.url === '');
            });

            const goToLog = () => {
                root.$router.push({ name: "LogbookRecord", params: { date: journey.value.favouriteDate, isFavourite: "true", journeyId: id } });
            };

            const showDialog = (index: number) => {
                selectedImageIndex.value = index;
                selectedImageIsPlaceholder.value = images.value[index].url === '';
                if (!selectedImageIsPlaceholder.value) {
                    showImageDialog.value = true;
                } else if (selectedImageIsPlaceholder.value && hasUploadAccess.value) {    
                    showImageDialog.value = true;
                } else {
                    app.error = "You do not have the permission to modify the gallery. Contact the captain in order to get permission.";
                }
            };

            const closeImageDialog = () => {
                showImageDialog.value = false;
                uploadFile.value = null;
                fileSelected.value = false;
            };

            const setShowImageDialog = (value: boolean) => {
                if (value) {
                    showImageDialog.value = true;
                    return;
                }

                closeImageDialog();
            };

            const handleImageUpload = async () => {
                const fileToUpload = uploadFile.value;
                if (!fileToUpload) {
                    return;
                }

                closeImageDialog();

                if (selectedImageIsPlaceholder.value && journey.value) {
                    uploading.value = true;
                    switch (selectedImageIndex.value) {
                        case 0:
                            journey.value.image1 = generateRandomFileName();
                            await uploadImage(journey.value.image1, fileToUpload);
                            await updateFavouriteJourney(journey.value);
                            break;
                        case 1:
                            journey.value.image2 = generateRandomFileName();
                            await uploadImage(journey.value.image2, fileToUpload);
                            await updateFavouriteJourney(journey.value);
                            break;
                        case 2:
                            journey.value.image3 = generateRandomFileName();
                            await uploadImage(journey.value.image3, fileToUpload);
                            await updateFavouriteJourney(journey.value);
                            break;
                        case 3:
                            journey.value.image4 = generateRandomFileName();
                            await uploadImage(journey.value.image4, fileToUpload);
                            await updateFavouriteJourney(journey.value);
                            break;
                        case 4:
                            journey.value.image5 = generateRandomFileName();
                            await uploadImage(journey.value.image5, fileToUpload);
                            await updateFavouriteJourney(journey.value);
                            break;
                        default:
                            break;
                    }
                    uploading.value = false;
                }
            };

            const handleImageDelete = async () => {
                closeImageDialog();

                switch (selectedImageIndex.value) {
                    case 0:
                        await deleteImageFromBlobStorage(journey.value.image1);
                        journey.value.image1 = "";
                        await updateFavouriteJourney(journey.value);
                        break;
                    case 1:
                        await deleteImageFromBlobStorage(journey.value.image2);
                        journey.value.image2 = "";
                        await updateFavouriteJourney(journey.value);
                        break;
                    case 2:
                        await deleteImageFromBlobStorage(journey.value.image3);
                        journey.value.image3 = "";
                        await updateFavouriteJourney(journey.value);
                        break;
                    case 3:
                        await deleteImageFromBlobStorage(journey.value.image4);
                        journey.value.image4 = "";
                        await updateFavouriteJourney(journey.value);
                        break;
                    case 4:
                        await deleteImageFromBlobStorage(journey.value.image5);
                        journey.value.image5 = "";
                        await updateFavouriteJourney(journey.value);
                        break;
                    default:
                        break;
                }

                images.value[selectedImageIndex.value].url = '';
            };

            const fetchImagesFromBlob = async () => {
                downloading.value = true;
                const ids = [journey.value.image1, journey.value.image2, journey.value.image3, journey.value.image4, journey.value.image5]
                const filenames = ids;

                downloadProgress.value = 0;

                let imageList = [];

                for (let filename of filenames) {
                    if (filename) {
                        const imageData = await downloadImageFromBlobStorage(filename);
                        const blob = new Blob([imageData], { type: IMAGE_FORMAT });
                        const url = URL.createObjectURL(blob);
                        imageList.push({ url: url });
                    } else {
                        // Using the empty image path when the filename is null
                        imageList.push({ url: '' });
                    }
                    downloadProgress.value += 20;
                }

                images.value = imageList;
                downloadProgress.value = 100;
                downloading.value = false;
                return imageList;
            };

            const handleFileChange = (file: File | undefined) => {
                if (file) {
                    uploadFile.value = file;
                    fileSelected.value = true;
                } else {
                    uploadFile.value = null;
                    fileSelected.value = false;
                }
            };

            const uploadImage = async (fileName: string, file: File) => {

                await uploadImageToBlobStorage(fileName, new Uint8Array(await file.arrayBuffer()));

                // Download the image from blob storage and display it
                const imageData = await downloadImageFromBlobStorage(fileName);
                const blob = new Blob([imageData], { type: IMAGE_FORMAT });
                const url = URL.createObjectURL(blob);

                images.value[selectedImageIndex.value].url = url;

                uploadFile.value = null; // Clear the selected file
                fileSelected.value = false; // Mark that no file is selected
            };

            const imageRules = ref([
                (value: File) => !value || (value.size < 5 * 1024 * 1024 && ['image/jpeg', 'image/png'].includes(value.type)) || 'Image size should be less than 5 MB and in JPG or PNG format!',
            ]);

            // Helper function to load an image
            const loadImage = (src: string): Promise<HTMLImageElement> => {
                return new Promise<HTMLImageElement>((resolve, reject) => {
                    const img = new Image();
                    img.onload = () => resolve(img);
                    img.onerror = reject;
                    img.src = src;
                });
            };


            // Helper function to download and prepare images
            const downloadAndPrepareImages = async (filenames) => {
                const imageList = [];
                for (let filename of filenames) {
                    if (filename) {
                        const imageData = await downloadImageFromBlobStorage(filename);
                        const blob = new Blob([imageData], { type: IMAGE_FORMAT });
                        const url = URL.createObjectURL(blob);
                        const img = await loadImage(url);
                        imageList.push(img);
                    }
                }
                return imageList;
            };

            // Helper function to calculate the total height of the canvas
            const calculateTotalHeight = (imageList: HTMLImageElement[], logImage?: HTMLImageElement): number => {
                let totalHeight = 0;

                // Add the starting height
                totalHeight += START_HEIGHT;

                // Calculate logImage height if included
                if (logImage) {
                    const logHeight = (CANVAS_WIDTH - 2 * (HORIZONTAL_GAP + BORDER_WIDTH)) * logImage.height / logImage.width;
                    totalHeight += logHeight + 2 * BORDER_WIDTH + VERTICAL_GAP;
                }

                // Calculate height for each image in the list
                for (let image of imageList) {
                    const scaledWidth = CANVAS_WIDTH - 2 * (HORIZONTAL_GAP + BORDER_WIDTH);
                    const scaledHeight = scaledWidth * image.height / image.width;
                    totalHeight += scaledHeight + 2 * BORDER_WIDTH + VERTICAL_GAP;
                }

                // Add a LARGE_VERTICAL_GAP after last image and subtract overflow (calculated manually)
                totalHeight += LARGE_VERTICAL_GAP - 32;

                return totalHeight;
            };

            const captureAndShareBase = async (includeLog = false) => {
                try {
                    showLoadingDialog.value = true;

                    // Fetch journey images
                    const filenames = [
                        journey.value.image1,
                        journey.value.image2,
                        journey.value.image3,
                        journey.value.image4,
                        journey.value.image5
                    ];

                    const imageList = await downloadAndPrepareImages(filenames);

                    const logoImg: HTMLImageElement = await loadImage(LOGO_IMAGE_PATH);
                    const background: HTMLImageElement = await loadImage(BACKGROUND_IMAGE_PATH);

                    // Load the logImage if required
                    let logImage: HTMLImageElement | undefined;
                    if (includeLog) {
                        const logImageData = await downloadImageFromBlobStorage(logFileName);
                        const logBlob = new Blob([logImageData], { type: IMAGE_FORMAT });
                        const logUrl = URL.createObjectURL(logBlob);
                        logImage = await loadImage(logUrl);
                    }

                    // Create canvas and its context
                    const canvas = document.createElement('canvas');
                    canvas.width = CANVAS_WIDTH;
                    canvas.height = calculateTotalHeight(imageList, logImage);
                    const ctx = canvas.getContext('2d');

                    // Draw the background
                    ctx.drawImage(background, 0, 0, CANVAS_WIDTH, canvas.height);

                    // Draw the logo
                    ctx.drawImage(logoImg, HORIZONTAL_GAP, VERTICAL_GAP, logoImg.width / 2, logoImg.height / 2);

                    // The position where the logo starts vertically (top-most point)
                    const logoStartY = VERTICAL_GAP;

                    // The height of the logo after scaling
                    const scaledLogoHeight = (logoImg.width / 2) * logoImg.height / logoImg.width;

                    // The position where the logo ends vertically (bottom-most point)
                    const logoEndY = logoStartY + scaledLogoHeight;

                    // Calculate mid-points for title and date relative to the logo's vertical position
                    const titleMidPoint = logoStartY + (scaledLogoHeight / 2);  // Half of the upper half
                    const dateMidPoint = logoStartY + scaledLogoHeight - 32;  // Half of the lower half

                    // Draw the title
                    ctx.font = "78px Arial";
                    ctx.fillStyle = ELEMENT_COLOR;
                    ctx.textAlign = "center";
                    const titleX = (canvas.width / 2) + (canvas.width / 5);
                    ctx.fillText(TITLE, titleX, titleMidPoint);

                    // Draw the date
                    const date = formattedDate.value;
                    ctx.font = "55px Arial";
                    ctx.fillStyle = ELEMENT_COLOR;
                    const dateX = (canvas.width / 2) + (canvas.width / 5);
                    ctx.fillText(date, dateX, dateMidPoint);

                    // Starting Y position for journey images
                    let currentY = logoStartY + scaledLogoHeight + VERTICAL_GAP;

                    // Optionally draw the log image
                    if (includeLog && logImage) {
                        const logHeight = (canvas.width - 2 * (HORIZONTAL_GAP + BORDER_WIDTH)) * logImage.height / logImage.width;
                        const logWidth = canvas.width - 2 * (HORIZONTAL_GAP + BORDER_WIDTH);

                        // Create the white border
                        ctx.fillStyle = ELEMENT_COLOR;
                        ctx.fillRect(
                            HORIZONTAL_GAP - BORDER_WIDTH,
                            currentY - BORDER_WIDTH,
                            logWidth + 2 * BORDER_WIDTH,
                            logHeight + 2 * BORDER_WIDTH
                        );

                        // Draw the log image inside the white border
                        ctx.drawImage(logImage, HORIZONTAL_GAP, currentY, logWidth, logHeight);

                        // Adjust currentY for subsequent images
                        currentY += logHeight + 2 * BORDER_WIDTH + VERTICAL_GAP;
                    }

                    for (let image of imageList) {
                        const scaledWidth = canvas.width - 2 * HORIZONTAL_GAP;
                        const scaledHeight = scaledWidth * image.height / image.width;

                        // Draw the white border/background
                        ctx.fillStyle = ELEMENT_COLOR;
                        ctx.fillRect(HORIZONTAL_GAP - BORDER_WIDTH, currentY - BORDER_WIDTH, scaledWidth + 2 * BORDER_WIDTH, scaledHeight + 2 * BORDER_WIDTH);

                        // Draw the image on top of the white background
                        ctx.drawImage(image, HORIZONTAL_GAP, currentY, scaledWidth, scaledHeight);

                        // Move to the position for the next image
                        currentY += scaledHeight + 2 * BORDER_WIDTH + VERTICAL_GAP;
                    }

                    // Handle the final image
                    canvas.toBlob(croppedBlob => {
                        file = new File([croppedBlob], SHARE_FILE_NAME, { type: IMAGE_FORMAT });
                        showLoadingDialog.value = false;
                        shareImageUrl.value = URL.createObjectURL(file);
                        showShareDialog.value = true;
                    }, IMAGE_FORMAT);

                    // Hide loading dialog
                    showLoadingDialog.value = false;

                } catch (err) {
                    showLoadingDialog.value = false;
                    app.error = "An error occurred while generating the image: " + err;
                    console.error("An error occurred:", err);
                }
            };

            const shareNow = () => {
                // only display the loading dialog if sharing is possible
                if ((navigator as any).canShare && (navigator as any).canShare({ files: [file] })) {

                    const shareData: any = {
                        files: [file],
                        title: 'MarineOne Journey Memories',
                        text: 'MarineOne journey memories from ' + formattedDate.value,
                    };

                    (navigator as any).share(shareData)
                        .then(() => {
                            console.log('Sharing successful.');
                        })
                        .catch((error: any) => {
                            app.error = error;
                        });
                } else {
                    app.error = `Your device doesn't support sharing files.`;
                }
            }

            const formattedDate = computed<string>(() => {
                const date = new Date(journey.value.favouriteDate);
                const day = date.getDate();
                const month = date.toLocaleString('en-US', { month: 'long' });
                const year = date.getFullYear();

                let daySuffix = 'th';
                if (day === 1 || day === 21 || day === 31) {
                    daySuffix = 'st';
                } else if (day === 2 || day === 22) {
                    daySuffix = 'nd';
                } else if (day === 3 || day === 23) {
                    daySuffix = 'rd';
                }

                return journey.value ? `${day}${daySuffix} of ${month}, ${year}` : "";
            });

            const compressImage = async (file) => {
                return new Promise((resolve) => {
                    const reader = new FileReader();
                    reader.readAsDataURL(file);
                    reader.onload = event => {
                        const img = new Image();
                        const result = event.target.result as string;
                        img.src = result;
                        img.onload = () => {
                            const canvas = document.createElement('canvas');
                            const ctx = canvas.getContext('2d');
                            canvas.width = img.width;
                            canvas.height = img.height;
                            ctx.drawImage(img, 0, 0);
                            canvas.toBlob((blob) => {
                                resolve(new File([blob], file.name, { type: 'image/webp' }));
                            }, 'image/webp', 1);
                        };
                    };
                });
            };

            function generateRandomFileName(length = 32): string {
                const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
                let result = '';
                for (let i = 0; i < length; i++) {
                    result += characters.charAt(Math.floor(Math.random() * characters.length));
                }
                return deviceId + "_" + result + '.jpeg';
            }

            onMounted(async () => {
                journey.value = await getFavouriteJourney(parseInt(id));
                fetchImagesFromBlob();
            });

            return {
                images,
                handleFileChange,
                uploadImage,
                uploading,
                fileSelected,
                downloading,
                showImageDialog,
                showDialog,
                closeImageDialog,
                setShowImageDialog,
                selectedImageIsPlaceholder,
                handleImageDelete,
                handleImageUpload,
                uploadFile,
                selectedImageIndex,
                imageRules,
                goToLog,
                downloadProgress,
                showExtras,
                showShareDialog,
                showLoadingDialog,
                captureAndShareBase,
                shareNow,
                shareImageUrl,
                hasValidImage,
                hasUploadAccess,
            };
        },
    });
</script>
<style lang="scss" scoped>
    .logoOnTop {
        left: 50%;
        transform: translateX(-50%);
    }
    .blackSheetStyle {
        z-index: 0;
    }
    .image-frame {
        border: 1px solid white;
    }

    ::v-deep .v-skeleton-loader .v-skeleton-loader__image {
        height: 250px;
    }
</style>